import { styled } from "@mui/material/styles";
import { Button, ButtonProps } from "@mui/material";
import { purple } from "@mui/material/colors";
import { colors } from "../../utility/types/constant";

export const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: colors.blueRibbon,
  "&:hover": {
    backgroundColor: colors.blueRibbon,
  },
}));

export const AcceptButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: colors.secondPrimary,
  "&:hover": {
    backgroundColor: colors.secondPrimary,
  },
}));

export const DenyButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: colors.persianRed,
  "&:hover": {
    backgroundColor: colors.persianRed,
  },
}));

export const SendAddRequestButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: colors.successGreen,
    "&:hover": {
      backgroundColor: colors.successGreen,
    },
  })
);
